import { Directive, HostListener, Inject, Input } from "@angular/core";
import { ImmutableRedux } from "../../../../redux/immutable-redux.service";
import { GenericFormActions } from "../../actions";
import { CommonFormManagerDirective } from "../../form-manager.directive";
import { FORM_CTAS_STATE_PROP } from "../../state-props";

@Directive({
    selector: "[cancel-form-cta]",
    exportAs: "CancelFormCta",
})
export class CancelFormCtaDirective {
    @Input() public stateProp: string;
    @Input() public formManager: CommonFormManagerDirective;

    constructor(
        public ngRedux: ImmutableRedux<any>,
        @Inject(FORM_CTAS_STATE_PROP) public rootProp,
    ) { }

    @HostListener("click", ["$event"])
    public clickCta(_event) {
        _event.stopPropagation();
        this.closeForm();
    }

    public closeForm() {
        this.formManager.closeForm();
        this.ngRedux.dispatchFactory(GenericFormActions.FORM_CLOSED, this.rootProp, this.stateProp);
    }
}
